module.exports = __webpack_public_path__ + "static/lms-screen-9b8310851453f386cf77fb3b534dbb69.jpg";